import { forwardRef } from 'react';
import { Select } from './Select';

// Kept for existing imports: SelectField is the exams task's name for the same "Dropdown / Native"
// control. It is <Select variant='field'> (see Select.js) — use Select in new code.
export const SelectField = forwardRef((props, ref) => <Select ref={ref} variant='field' {...props} />);
SelectField.displayName = 'SelectField';

export default SelectField;
